const getClubSlugFromName = (name?: string): string | undefined => {
	if (!name) {
		return undefined;
	}

	return name
		.split(",")[0]
		?.trim()
		.toLowerCase()
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "");
};

export const normalizeLocationParam = (location?: string): string | undefined => {
	if (!location) {
		return undefined;
	}

	return location
		.trim()
		.toLowerCase()
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "");
};

export const findClubByLocation = (
	clubs:
		| Array<{
				Name?: string;
				ClubID?: number;
				RequireCheckPrice?: boolean;
		  }>
		| undefined,
	location: string,
) => {
	const normalizedLocation = normalizeLocationParam(location);
	if (!normalizedLocation || !Array.isArray(clubs)) {
		return undefined;
	}

	return clubs.find(
		(club) => getClubSlugFromName(club?.Name) === normalizedLocation,
	);
};

export default getClubSlugFromName;

export const getPricingUrlWithLocation = (club?: { Name?: string }): string => {
	const location = getClubSlugFromName(club?.Name);
	if (!location) {
		return "?step=pricing";
	}

	return `?step=pricing&location=${encodeURIComponent(location)}`;
};
